import * as React from 'react';

import classnames from 'classnames';
import {connect} from 'react-redux';

import { AppBar, Badge, IconButton, Toolbar, withStyles } from '@material-ui/core';

import Settings from '@material-ui/icons/Settings';
import Sync from '@material-ui/icons/Sync';
import SyncProblem from '@material-ui/icons/SyncProblem';

import { toggleFullScreen } from "../fullScreenHandler";
import AnimatedSyncIcon from '../icons/AnimatedSyncIcon';
import { state as ConnectionState } from '../redux/modules/connection';
import ITeamState from '../redux/modules/team/state';
import SettingsDialog from './SettingsDialog';
import {isInTeam} from "../redux/modules/team/selectors";

const styles = (theme:any) => ({
    appbar: {
        background: 'none',
        boxShadow: 'none',
    },
    button: {
        color: '#fff'
    },
    grow: {
        flexGrow: 1,
    },
    logo: {
        height: '50px',
    }
});

const mapStateToProps = (state:any) => ({
    connection: state.connection,
    team: state.team,
});

interface IHeaderComponentProps {
    classes:any;
    connection:ConnectionState,
    team:ITeamState;
    className?:any;
}

interface IHeaderComponentState {
    open:boolean;
    team:ITeamState,
}

class HeaderComponet extends React.Component<IHeaderComponentProps, IHeaderComponentState> {

    public state = {
        open: false,
    } as IHeaderComponentState;

    constructor(props:IHeaderComponentProps) {
        super(props);

        this.handleSettingsClick = this.handleSettingsClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    public render() {
        return (
            <div>
                <AppBar position='static' className={ classnames( this.props.classes.appbar, this.props.className ) }>
                    <Toolbar>
                        <div className={ this.props.classes.grow } onClick={toggleFullScreen} title={"Toggle fullscreen"} style={{ cursor: 'pointer'}}>
                            <img className={ this.props.classes.logo } src="/images/tomodoro-logo.min.svg"/>
                        </div>
                        { this.getSocketStatus() }
                        <IconButton onClick={ this.handleSettingsClick } className={ this.props.classes.settings } disabled={ !isInTeam(this.props.team) }>
                            <Settings/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <SettingsDialog open={ this.state.open } onClose={ this.handleClose }/>
            </div>
        );
    }

    private handleSettingsClick(event:React.SyntheticEvent) {
        this.setState({ open: true });
    }

    private handleClose(event:React.SyntheticEvent) {
        this.setState({ open: false });
    }

    private getSocketStatus() {
        if(this.props.connection.connected) {
            return (<Sync/>);
        } else if(this.props.connection.pending) {
            return (
                <Badge badgeContent={ this.props.connection.reconnectionAttempts } color="secondary">
                    <AnimatedSyncIcon/>
                </Badge>
            )
        }
        return (
            <SyncProblem color="error"/>
        );
    }
};

export default
    connect(mapStateToProps)(withStyles(styles)(HeaderComponet));



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.tsx